<template>
  <div
    ref="target"
    class="tw-relative"
    :class="[isClosed ? 'tw-px-0' : 'tw-mx-2']"
  >
    <button
      class="tw-flex tw-min-h-[52px] tw-w-full tw-items-center tw-justify-between tw-bg-aside-400 tw-py-2 tw-text-base tw-font-bold tw-text-white tw-outline-none tw-outline-4 tw-outline-offset-0 tw-transition-all hover:tw-bg-aside-300 dark:tw-text-dorian-gray-500"
      :class="[
        isClosed ? 'tw-px-2' : 'tw-px-6',
        isOpen && !isClosed ? 'tw-rounded-b-0 tw-rounded-t' : '',
        !isOpen && !isClosed ? 'tw-rounded-b tw-rounded-t' : '',
      ]"
      type="button"
      :data-test-id="props.testId"
      @click="toggleMenu"
    >
      <span class="tw-sr-only">Dropdown</span>
      <slot name="title" />
      <ClIconTablerChevronDown
        class="tw-min-w-[16px] tw-transition-transform"
        :class="chevronIconClass"
      />
    </button>
    <div
      v-if="isOpen"
      class="tw-outline-t-0 tw-absolute tw-right-0 tw-z-10 tw-flex tw-w-full tw-flex-col tw-rounded-b-md tw-border tw-border-aside-300/80 tw-bg-aside-400 tw-shadow tw-transition-opacity"
      :class="[
        classes,
        props.isNarrow ? 'tw-min-w-[180px]' : 'tw-min-w-[240px]',
      ]"
      @click="isOpen = false"
    >
      <div class="tw-relative">
        <slot name="search" />
      </div>
      <div class="tw-relative">
        <ul class="tw-max-h-[50dvh] tw-w-full tw-overflow-y-auto">
          <slot name="menu" />
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { onClickOutside } from "@vueuse/core";

import { ClIconTablerChevronDown } from "../icons";

export interface DropdownProps {
  testId?: string;
  isClosed: boolean;
  isNarrow?: boolean;
}

const props = withDefaults(defineProps<DropdownProps>(), {
  testId: "cl-dropdown-toggle-btn",
});

const isOpen = ref(false);

const target = ref(null);
onClickOutside(target, () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
});

const classes = computed(() => {
  return [
    isOpen.value ? "tw-opacity-100" : "tw-opacity-0",
    props.isClosed ? "tw-absolute tw-left-[100%] tw-top-0" : "",
  ];
});
const emit = defineEmits<{
  (event: "on-dropdown"): void;
}>();
const chevronIconClass = computed(() => {
  if (props.isClosed) {
    return isOpen.value ? "tw-rotate-90" : "tw-rotate-[270deg]";
  } else {
    return isOpen.value ? "tw-rotate-180" : "tw-rotate-0";
  }
});
const toggleMenu = () => {
  isOpen.value = !isOpen.value;

  if (isOpen.value) {
    emit("on-dropdown");
  }
};
</script>

<style scoped></style>
